import React, { forwardRef, useState } from 'react';

import ReactSelect from 'react-select';

export const selectCustomStyles = {
    container: (provided, state) => ({
        ...provided,
        width: '100%',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "48px"
    }),
    control: (styles) => ({ ...styles, backgroundColor: '#F9FAFB', width: "100%", borderRadius: "12px", borderColor: "#E1E7EC" }),

    singleValue: (styles) => ({ ...styles, color: "#809FB8" }),
    placeholder: (styles) => ({ ...styles, color: "#c0cfdc" }),
    menu: (def) => ({ ...def, }),
}

export const Select = forwardRef(({
    options,
    onChange,
    value,
    label,
    name,
    loading,
    placeholder = "Select ...",
    disabledSearch = false,
    isClearable = true,
    isDisabled,
    onStateChanges,
    defaultValues
}, ref
) => {
    // const [isLoading, setIsLoading] = useState(false);
    const [isRtl, setIsRtl] = useState(false);
    const [selectedValue, setSelectedValue] = useState(options[0])

    return (
        <>
            <ReactSelect
                styles={selectCustomStyles}
                defaultValue={defaultValues && defaultValues}
                value={value}
                onChange={(newValue) => {
                    onStateChanges && onStateChanges(newValue)
                    onChange(newValue ? newValue.value : undefined);
                    setSelectedValue(newValue);
                }}
                className="basic-single"
                classNamePrefix="select"
                isDisabled={isDisabled}
                isLoading={loading}
                isClearable={isClearable}
                isRtl={isRtl}
                placeholder={placeholder}

                isSearchable={!disabledSearch}
                name={name}
                options={options}
                ref={ref}
                menuPlacement='auto'


            />

        </>
    );
})